import { pbrAxios } from '../../common/js/pbrAxios'

/**
 * 专题详情
 * @param params
 * @param {String} params.id:
 * @returns {AxiosPromise<any>}
 */
const getTopic = (params) => pbrAxios.get('/front/special/getSpecial', {params})

/**
 * 专题相关项目
 * @param params
 *  @param {String} params.id:
 *  @param {String} params.lang:
 * @returns {AxiosPromise<any>}
 */
const getSpecialProject = params => {
  return pbrAxios.get('/front/special/querySpecialProject', {params})
}

/**
 * 相关区域分布
 * @param params
 *  @param {String} params.id:
 *  @param {String} params.lang:
 * @returns {AxiosPromise<any>}
 */
const  getRegionalDistribution = params => pbrAxios.get('/front/special/regionalDistribution', {params})

/**
 * 行业分布
 * @param params
 *  @param {String} params.id:
 *  @param {String} params.lang:
 * @returns {AxiosPromise<any>}
 */
const  getIndustryDistribution = params => pbrAxios.get('/front/special/industryDistribution', {params})


/**
 * 专题资讯
 * @param params
 *  @param {String} params.id:
 * @returns {AxiosPromise<any>}
 */
const  getTopicNews = params => pbrAxios.get('/front/special/querySpecialNews', {params})
/**
 * 专题资讯
 * @param params
 *  @param {String} params.id:
 *  @param {String} params.lang:
 * @returns {AxiosPromise<any>}
 */
const  getTopicHotWord = params => pbrAxios.get('/front/special/ghotword', {params})

/**
 * 专题列表
 * @param params
 *  @param {String} params.lang:
 * @returns {AxiosPromise<any>}
 */
const  getSpecialAll = params => pbrAxios.get('/front/special/getSpecialAll', {params})

export default {
  getTopic,
  getSpecialProject,
  getRegionalDistribution,
  getIndustryDistribution,
  getTopicNews,
  getTopicHotWord,
  getSpecialAll
}
